import React, { useState } from "react";
import { createPortal } from "react-dom";
import { ChevronDown, Image as ImageIcon, X } from "lucide-react";

// Фото/видео, приложенные заказчиком к заданию — доступны исполнителю на этапе обсуждения,
// чтобы оценить объём работ и цену ДО принятия задания.
// Ж23 (TZ-7 п.8): аккордеон свёрнут по умолчанию, миниатюры — горизонтальной лентой, просмотр — через портал
export const TaskReferenceMedia = ({ task }) => {
  const [open, setOpen] = useState(false);
  const [viewer, setViewer] = useState(null);

  React.useEffect(() => {
    if (!viewer) return;
    const onKey = e => { if (e.key === "Escape") setViewer(null); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [viewer]);

  const media = (task?.reference_media || []).filter(
    m => typeof m === "string" && (m.startsWith("data:image") || m.startsWith("data:video"))
  );
  if (media.length === 0) return null;

  return (
    <div className="border-b" style={{ background: "#F0FDFA", borderColor: "#99F6E4" }}>
      <button
        type="button"
        data-testid="reference-media-toggle"
        aria-expanded={open}
        onClick={() => setOpen(v => !v)}
        className="w-full px-4 min-h-[40px] flex items-center gap-2 text-left text-xs font-medium"
        style={{ color: "#0F766E", background: "transparent", border: "none", cursor: "pointer" }}
      >
        <ImageIcon size={14} className="flex-shrink-0" />
        <span className="flex-1 min-w-0 truncate">Фотографии к заданию ({media.length}) — оцените объём работ до принятия</span>
        <ChevronDown size={15} className="flex-shrink-0" style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform 0.15s" }} />
      </button>
      {open && (
        <div className="pb-3" data-testid="reference-media-grid">
          <div className="flex gap-2 overflow-x-auto px-4 pb-1 snap-x" style={{ scrollbarWidth: "thin" }} data-testid="reference-media-strip">
            {media.map((m, index) => (
              <div key={index} className="relative flex-shrink-0 snap-start bg-white rounded-lg overflow-hidden border" style={{ borderColor: "#99F6E4", width: 84, height: 84 }}>
                {m.startsWith("data:image") ? (
                  <img
                    src={m}
                    alt={`Фото ${index + 1}`}
                    data-testid={`reference-media-thumb-${index}`}
                    className="w-full h-full object-cover cursor-pointer hover:opacity-85 transition-opacity"
                    onClick={() => setViewer({ src: m, index: index + 1 })}
                  />
                ) : (
                  <video src={m} className="w-full h-full object-cover" controls preload="metadata" />
                )}
                <div className="absolute top-1 right-1 text-white text-xs px-1.5 rounded-full pointer-events-none" style={{ background: "#0D9488" }}>
                  {index + 1}
                </div>
              </div>
            ))}
          </div>
          <p className="text-xs mt-1 px-4" style={{ color: "#0F766E" }}>
            Нажмите на фото, чтобы открыть в полном размере
          </p>
        </div>
      )}
      {viewer && createPortal(
        <div
          data-testid="reference-media-viewer"
          className="fixed inset-0 flex items-center justify-center p-4"
          style={{ background: "rgba(0,0,0,0.85)", zIndex: 10050 }}
          onClick={() => setViewer(null)}
        >
          <button
            type="button"
            data-testid="reference-media-viewer-close"
            className="absolute top-4 right-4 text-white hover:opacity-70"
            style={{ background: "none", border: "none", cursor: "pointer" }}
            onClick={() => setViewer(null)}
            aria-label="Закрыть"
          >
            <X size={28} />
          </button>
          <img
            src={viewer.src}
            alt={`Фото ${viewer.index}`}
            className="max-w-full max-h-full object-contain rounded"
            onClick={e => e.stopPropagation()}
          />
        </div>,
        document.body
      )}
    </div>
  );
};
